import { render, staticRenderFns } from "./TableImport.vue?vue&type=template&id=9f874286"
import script from "./TableImport.vue?vue&type=script&lang=js"
export * from "./TableImport.vue?vue&type=script&lang=js"
import style0 from "./TableImport.vue?vue&type=style&index=0&id=9f874286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports